import styled from "styled-components";

export const CrossBrandItemIconDefaultBox = styled.div`
  margin: 0 0 2px 0;

  @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
    transform: scale(0.85);
  }

  width: 30px;
  height: 20px;
  background: url(${props => props.theme.images.spriteSheet.toString()});

  &.casino-brand {
    background-position: -268px -679px;
  }
  &.sport-brand {
    background-position: -158px -679px;
  }
  &.poker-brand {
    background-position: -103px -679px;
  }
  &.com-brand {
    background-position: -43px -681px;
  }
  &.bingo-brand {
    background-position: -213px -681px;
  }
  &.games-brand {
    background-position: -323px -681px;
  }
`;
